module.exports = __webpack_public_path__ + "static/img/doorder-login-background.9c8541d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doorder/doorder-login-background.png
// module id = 4mq2
// module chunks = 0